<template>
  <section class="Home" id="home-page">
    <App-MainSlider class="hide-on-mobile" />
    <App-MainSlider-Mobile class="show-on-mobile" />
    <App-featured-products />
    <AppHomeBanner />
    <App-OurClients />
    <App-Accessories />
  </section>
</template>

<script>
import HomeBanner from "@/components/HomeBanner";
import MainSlider from "@/components/MainSlider";
import LayoutDefault from "@/layouts/LayoutDefault";
import OurClients from "@/components/OurClients.vue";
import Accessories from "@/components/Accessories.vue";
import FeaturedProducts from "@/components/FeaturedProducts.vue";
import MainSliderMobile from "@/components/shared/MainSliderMobile";

export default {
  name: "home",
  components: {
    AppMainSlider: MainSlider,
    AppMainSliderMobile: MainSliderMobile,
    AppHomeBanner: HomeBanner,
    AppFeaturedProducts: FeaturedProducts,
    AppOurClients: OurClients,
    AppAccessories: Accessories
  },
  data() {
    return {};
  },
  created() {
    this.$emit("update:layout", LayoutDefault);
    this.$root.$emit("closenav", false);
  }
};
</script>
